import { useRouter } from 'next/router';
import { WithDefaultLayout } from '../components/DefautLayout';
import { Page } from '../types/Page';

const IndexPage: Page = () => {
    const router = useRouter();

    router.push('/users');
    return null;
}

IndexPage.layout = WithDefaultLayout;
export default IndexPage;
